import {
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    useReactTable,
} from "@tanstack/react-table";
import { useState } from 'react';
import { Link } from 'react-router';
import '../../App.css';
import { DataTable } from './datatable';
import DatatableSortButton from './datatableSortButton';

const customPlacingSort = (rowA, rowB, columnId) => {
    const a = rowA.getValue(columnId);
    const b = rowB.getValue(columnId);

    if (a === null) return 1;
    if (b === null) return -1;
    return a > b ? 1 : -1;
};


export const columns = [
    {
        accessorKey: "placing",
        header: ({ column }) => <DatatableSortButton column={column}>Placering</DatatableSortButton>,
        cell: info => info.getValue() === null ? "opl" : info.getValue(),
        sortingFn: customPlacingSort,
    },
    {
        accessorKey: "bunny_id",
        header: ({ column }) => <DatatableSortButton column={column}>Kanin</DatatableSortButton>,
        cell: info => (<Link className='text-blue-600 font-medium hover:underline' to={`/bunny/${info.row.original.bunny.id}`}>{info.row.original.bunny.name}</Link>) || "Inget kaninnamn",
    },
    {
        accessorKey: "driver_id",
        header: ({ column }) => <DatatableSortButton column={column}>Förare</DatatableSortButton>,
        cell: info => (info.row.original.driver.first_name + ' ' + info.row.original.driver.last_name)
    },
    {
        accessorKey: "points",
        header: ({ column }) => <DatatableSortButton column={column}>Poäng</DatatableSortButton>,
        cell: info => info.getValue(),
    },
    {
        accessorKey: "totalRounds",
        header: ({ column }) => <DatatableSortButton column={column}>Antal omgångar</DatatableSortButton>,
        cell: info => {
            const placing = info.row.getValue('placing');
            return placing === null ? null : info.getValue();
        },
    },
    {
        accessorKey: "totalFaults",
        header: ({ column }) => <DatatableSortButton column={column}>Totala fel</DatatableSortButton>,
        cell: info => {
            const placing = info.row.getValue('placing');
            return placing === null ? null : info.getValue();
        },
    },
    {
        accessorKey: "totalTime",
        header: ({ column }) => <DatatableSortButton column={column}>Totaltid</DatatableSortButton>,
        cell: info => {
            const placing = info.row.getValue('placing');
            return placing === null ? null : info.getValue();
        },
    },
];

export function CupResultsDatatable({ cupResults, isLoading }) {
    const [sorting, setSorting] = useState([{ id: "placing", desc: false }]);
    const [columnFilters, setColumnFilters] = useState([]);

    const table = useReactTable({
        data: cupResults,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        onSortingChange: setSorting,
        getSortedRowModel: getSortedRowModel(),
        onColumnFiltersChange: setColumnFilters,
        getFilteredRowModel: getFilteredRowModel(),
        state: {
            sorting,
            columnFilters,
            pagination: {
                pageIndex: 0,
                pageSize: 9999,
              },
        },
    });

    return (
        <DataTable
            table={table}
            isLoading={isLoading} // Adjust based on actual loading state
            columns={columns}
        />
    );
}
